// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import API from '../api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const response = await API.post('/auth/forgot-password', { email });

      if (response.data.success) {
        setMessage(response.data.message);
        setEmail(''); // Pulisce il campo email
      } else {
        setMessage(response.data.message || 'Errore nella richiesta di reset password.');
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'Errore di rete.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        {/* Header con icona */}
        <div className="reset-password-header">
          <div className="reset-password-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="reset-password-title">Password Dimenticata</h2>
          <p className="reset-password-subtitle">Inserisci la tua email e riceverai un link per reimpostare la password</p>
        </div>
        
        {message && (
          <div className={`${message.includes('riceverai') ? 'reset-password-success' : 'reset-password-error'}`}>
            <svg className={`${message.includes('riceverai') ? 'reset-password-success-icon' : 'reset-password-error-icon'}`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              {message.includes('riceverai') ? (
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              ) : (
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              )}
              {message.includes('riceverai') ? (
                <polyline points="22,4 12,14.01 9,11.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              ) : (
                <>
                  <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </>
              )}
            </svg>
            {message}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="reset-password-form">
          <div className="reset-password-form-group">
            <label className="reset-password-form-label">Email</label>
            <div className="reset-password-input-wrapper">
              <svg className="reset-password-input-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <input
                type="email"
                className="reset-password-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Inserisci la tua email"
                required
                disabled={isLoading}
              />
            </div>
          </div>
          <button 
            type="submit" 
            className="reset-password-submit-btn"
            disabled={isLoading}
          >
            <span>{isLoading ? 'Invio in corso...' : 'Invia Link di Reset'}</span>
            <svg className="reset-password-submit-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="m12 5 7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </form>
        
        <div className="reset-password-footer">
          <Link to="/login" className="reset-password-back-link">
            ← Torna al Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword; 